import React, { useState } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import AssetsList from './AssetsList';
import Season2Img from 'assets/images/home/season-2.png';
import Season3Img from 'assets/images/home/season-3.png';
import Season4Img from 'assets/images/home/season-4.png';
import Season2ShareBG from 'assets/images/home/season2-share-bg.png';
import Season3ShareBG from 'assets/images/home/season3-share-bg.png';
import Season4ShareBG from 'assets/images/home/season4-share-bg.png';
import LinkSvg from 'assets/images/home/link.svg';
import Xsvg from 'assets/images/home/x.svg';
import Button from 'components/Button';
import { ReactComponent as CopySVG } from 'assets/images/home/copy.svg';
import { ReactComponent as TaskSVG } from 'assets/images/home/task.svg';
import { ReactComponent as VerifySVG } from 'assets/images/home/verify.svg';
import { ReactComponent as BridgeSVG } from 'assets/images/home/bridge.svg';
import { ReactComponent as SatoshiSVG } from 'assets/images/home/satoshi.svg';
import { ReactComponent as RocketSVG } from 'assets/images/home/rocket.svg';
import { ReactComponent as SwapSVG } from 'assets/images/home/swap.svg';
import Copy from 'components/Copy';
import EasterEgg from './EasterEgg';
import { isMobile } from 'react-device-detect';
import { TYPE } from 'theme';
import user from 'stores/user';
import Row, { AutoRow, RowBetween } from 'components/Row';
import { ArrowIcon } from 'components/Icons';
import { AutoColumn } from 'components/Column';
import { Grid } from 'components/Grid';
import SocialMediaShare from 'utils/share';
import ExpandableSection from 'components/ExpandableSection';
import { useHistory, useLocation } from 'react-router-dom';
import missionStore from 'stores/missionStore';
import MissionCenter from './missionCenter';
import OverviewBox from './OverviewBox';
import { luckyDrawPath } from 'constant/route-path';
import { DiscordIcon } from 'common-helpers/img';

const Wrapper = styled.div`
    position: relative;
    margin: 0 auto;
    width: 100%;

    /* ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 0 24px;
    `}; */

    .path {
        z-index: 1;
        max-width: 1177px;
        margin: 0 auto;
        position: absolute;
        left: 50%;
        transform: translateX(-54%);
        top: -108px;

        ${({ theme }) => theme.mediaWidth.upToSmall`
            top: -120px;
            max-width: 364px;
            left: -9%;
            transform: translate(80px, 320px);
        `};
    }
`;

const RelativeWrapper = styled.div`
    position: relative;
`;

const MuiButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
    border-radius: 8px;
    width: 28px;
    height: 20px;
`;

const Step = styled.div`
    position: relative;
    z-index: 2;
    color: #ffffff;

    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 100%;
    margin-bottom: 60px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        margin-bottom: 50px;
    `};

    .row {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

    .cardTitle {
        max-width: 840px;
    }

    .cardDesc {
        max-width: 680px;
        font-size: 16px;

        ${({ theme }) => theme.mediaWidth.upToSmall`
            font-size: 14px;
        `};
    }

    &:last-child {
        ${({ theme }) => theme.mediaWidth.upToSmall`
            margin-bottom: 80px;
        `};
    }

    .season {
        padding: 10px 30px;
        border: 1px solid #fff;
        border-radius: 30px;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 16px;
        ${({ theme }) => theme.mediaWidth.upToSmall`
            font-size: 16px;
            padding: 8px 20px;
        `};
    }

    &.row-end {
        .row {
            align-items: flex-end;
            text-align: right;
        }
    }

    &.row-start {
        .row {
            align-items: flex-start;
            text-align: left;
        }
    }

    &:last-child {
        margin-bottom: 0px;
    }
`;

const Flex = styled.div`
    display: flex;
`;

const EasterEggWrapper = styled.div<{
    top?: string;
    left?: string;
    right?: string;
    bottom?: string;
}>`
    position: absolute;
    ${({ top }) => top && `top: ${top}`};
    ${({ left }) => left && `left: ${left}`};
    ${({ right }) => right && `right: ${right}`};
    ${({ bottom }) => bottom && `bottom: ${bottom}`};
`;

export const Content = styled.div`
    margin: 0 auto;
`;

const StyledCopySVG = styled(CopySVG)`
    width: 12px;
    height: 12px;
    cursor: pointer;
    flex-shrink: 0;
`;

const StyledVerifySVG = styled(VerifySVG)`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: #f7931a;
`;

const StyledTaskSVG = styled(TaskSVG)`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: #f7931a;
`;

const StyledBridgeSVG = styled(BridgeSVG)`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #f7931a;
`;

const StyledSatoshiSVG = styled(SatoshiSVG)`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #f7931a;
`;

const StyledRocketSVG = styled(RocketSVG)`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    color: #f7931a;
`;

const StyledSwapSVG = styled(SwapSVG)`
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    color: #f7931a;
`;

const Season4Wrapper = styled.div`
    background: url(${Season4ShareBG}) no-repeat center center;
    background-size: cover;
    border-radius: 16px;
    position: relative;
    z-index: 1;
    height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    flex-direction: column;
    text-aligin: center;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        height: 240px;
        gap: 20px;
    `};
`;

const ShareContentWrapper = styled.div`
    background: url(${Season3ShareBG}) no-repeat center center;
    background-size: cover;
    border-radius: 16px;
    position: relative;
    z-index: 1;
    height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    flex-direction: column;
    text-aligin: center;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        height: 240px;
        gap: 20px;
    `};
`;

const ShareContentSeason2Wrapper = styled.div`
    background: url(${Season2ShareBG}) no-repeat center center;
    background-size: cover;
    border-radius: 16px;
    position: relative;
    z-index: 1;
    height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    flex-direction: column;
    text-aligin: center;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        height: 240px;
        gap: 20px;
    `};
`;

const BorderedButton = styled(Button).attrs({
    size: 'unset',
    type: 'outlineGradient',
})`
    padding: 8px 20px !important;
    border-radius: 28px !important;
    transition: all 0.3s ease;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
        transform: translateY(-2px);
    }
`;

const StepCard = styled.div<{ isActive: boolean }>`
    cursor: pointer;
    padding: 30px;
    border-radius: 12px;
    display: flex;
    height: 120px;
    justify-content: space-between;
    background:
        linear-gradient(0deg, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0)),
        linear-gradient(
            90deg,
            rgba(247, 147, 26, 0.35) 0%,
            rgba(106, 13, 173, 0.15) 67.5%,
            rgba(106, 13, 173, 0.5) 100%
        ),
        linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 32.22%);
    position: relative;

    ${({ isActive }) =>
        isActive &&
        `
        &::before {
            content: "";
            position: absolute;
            top: -2px;
            left: -2px;
            right: -2px;
            bottom: -2px;
            border-radius: 12px;
            padding: 2px;
            background: linear-gradient(180deg, #FAD218 0%, rgba(247, 147, 26, 0) 100%);
            -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
        }
    `}
`;

const LinkLuckyDrawButton = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    padding: 7px 15px;
    background: transparent;
    border: 1px solid #f7931a;
    border-radius: 32px;
    transition: all 0.3s ease;
    flex-shrink: 0;
    justify-content: center;
    &:hover {
        opacity: 0.8;
    }
`;

// // 创建一个 StepButton 组件来处理导航
const StepButton = ({
    icon: Icon,
    buttonText,
    isCopy,
    text,
    onClick,
}: {
    icon: any;
    buttonText: string;
    isCopy?: boolean;
    text?: string;
    onClick?: () => void;
}) => {
    if (isCopy && text) {
        return (
            <Copy
                style={{
                    alignSelf: 'center',
                }}
                text={text}
                render={(onCopy) => (
                    <MuiButton
                        onClick={onCopy}
                        style={{
                            background: 'transparent',
                            cursor: 'pointer',
                            border: '1px solid #F7931A',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '4px 12px',
                            borderRadius: '24px',
                            height: '24px',
                            width: 'auto',
                            alignSelf: 'center',
                        }}
                    >
                        <Icon />
                        <TYPE.desc fontSize="12px">{buttonText}</TYPE.desc>
                    </MuiButton>
                )}
            />
        );
    }

    return (
        <MuiButton
            onClick={onClick}
            style={{
                background: 'transparent',
                cursor: 'pointer',
                border: '1px solid #F7931A',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '4px 12px',
                borderRadius: '24px',
                height: '24px',
                width: 'auto',
                alignSelf: 'center',
            }}
        >
            <Icon />
            <TYPE.desc fontSize="12px">{buttonText}</TYPE.desc>
        </MuiButton>
    );
};

// 创建一个专门处理导航的 StepButton 组件
const StepButtonWithNavigation = ({ icon: Icon, buttonText }: { icon: any; buttonText: string }) => {
    const history = useHistory();
    const location = useLocation();

    const handleClick = () => {
        history.push({
            pathname: '/dashboard',
            search: location.search,
            state: { scrollTo: 'taskVerification' },
        });
    };

    return (
        <MuiButton
            onClick={handleClick}
            style={{
                background: 'transparent',
                cursor: 'pointer',
                border: '1px solid #F7931A',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '4px 12px',
                borderRadius: '24px',
                height: '24px',
                width: 'auto',
                alignSelf: 'center',
            }}
        >
            <Icon />
            <TYPE.desc fontSize="12px">{buttonText}</TYPE.desc>
        </MuiButton>
    );
};

const STEP_2_TITLE = 'Step 2: Verify your Interactions';

interface StepConfig {
    title: string;
    desc: string;
    icon: any;
    buttonText: string;
    isCopy?: boolean;
    contentRender: () => JSX.Element;
}

const stepsConfig: StepConfig[] = [
    {
        title: 'Step1: Complete on Chain Tasks',
        desc: 'Complete on-chain tasks to earn Points',
        icon: StyledTaskSVG,
        buttonText: 'GO',
        contentRender: () => (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: '#1C1C1C',
                    borderRadius: '16px',
                    padding: '20px',
                    gap: '16px',
                }}
            >
                <TYPE.main>Complete one of following Task, Gain GOAT Points</TYPE.main>
                <Grid col={4}>
                    <AutoColumn gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <RowBetween>
                            <StyledBridgeSVG />
                            <MuiButton
                                style={{ background: '#f7931a', cursor: 'pointer' }}
                                onClick={() => {
                                    window.open('https://bridge.goat.network/', '_blank');
                                }}
                            >
                                <ArrowIcon color="#000" width={8} height={8} />
                            </MuiButton>
                        </RowBetween>
                        <TYPE.desc fontSize="14px" fontWeight={500}>
                            Bridge
                        </TYPE.desc>
                        <TYPE.desc fontSize="12px">
                            💰 Bridging at least 0.0002 BTC from an exchange or BTC Mainnet to the GOAT Network.
                        </TYPE.desc>
                    </AutoColumn>
                    <AutoColumn gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <RowBetween>
                            <StyledSatoshiSVG />
                            <MuiButton
                                style={{ background: '#f7931a', cursor: 'pointer' }}
                                onClick={() => {
                                    window.open('https://www.satoshigoat.xyz/', '_blank');
                                }}
                            >
                                <ArrowIcon color="#000" width={8} height={8} />
                            </MuiButton>
                        </RowBetween>
                        <TYPE.desc fontSize="14px" fontWeight={500}>
                            Satoshi.ai
                        </TYPE.desc>
                        <TYPE.desc fontSize="12px">🎯 Participate in one Satoshi GOAT game interaction.</TYPE.desc>
                    </AutoColumn>
                    <AutoColumn gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <RowBetween>
                            <StyledRocketSVG />
                            <MuiButton
                                style={{ background: '#f7931a', cursor: 'pointer' }}
                                onClick={() => {
                                    window.open('https://goatrocket.io/', '_blank');
                                }}
                            >
                                <ArrowIcon color="#000" width={8} height={8} />
                            </MuiButton>
                        </RowBetween>
                        <TYPE.desc fontSize="14px" fontWeight={500}>
                            GOAT Rocket
                        </TYPE.desc>
                        <TYPE.desc fontSize="12px">🎯 Play one game of GOAT Rocket </TYPE.desc>
                    </AutoColumn>
                    <AutoColumn gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <RowBetween>
                            <StyledSwapSVG />
                            <Row gap="10px" width="fit-content">
                                <BorderedButton
                                    onClick={() => {
                                        window.open('https://goatswap.fi/', '_blank');
                                    }}
                                >
                                    <TYPE.desc fontSize="12px">Goatswap</TYPE.desc>
                                    <img src={LinkSvg} alt="link" />
                                </BorderedButton>
                                <BorderedButton
                                    onClick={() => {
                                        window.open(
                                            'https://oku.trade/app/goat/trade/0x0000000000000000000000000000000000000000?inputSide=Sell',
                                            '_blank',
                                        );
                                    }}
                                >
                                    <TYPE.desc fontSize="12px">Oku</TYPE.desc>
                                    <img src={LinkSvg} alt="link" />
                                </BorderedButton>
                            </Row>
                        </RowBetween>
                        <TYPE.desc fontSize="14px" fontWeight={500}>
                            Swap
                        </TYPE.desc>
                        <TYPE.desc fontSize="12px">
                            🔁 Use Oku or GoatSwap to perform a swap between any two tokens (excluding BTC/WGBTC and
                            GOLA trading pairs).{' '}
                        </TYPE.desc>
                    </AutoColumn>
                </Grid>
            </div>
        ),
    },
    {
        title: STEP_2_TITLE,
        desc: 'Verify your on-chain task interaction',
        icon: StyledVerifySVG,
        buttonText: 'GO',
        contentRender: () => (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: '#1C1C1C',
                    borderRadius: '16px',
                    padding: '20px',
                    gap: '16px',
                }}
            >
                <TYPE.main>verify your on-chain activities, Share GOAT Network Token</TYPE.main>
                <Grid col={4}>
                    <Row gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '20px',
                                height: '20px',
                                color: '#F7931A',
                                background: 'rgba(247,147, 26,0.2)',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            1
                        </TYPE.desc>
                        <AutoColumn gap="20px">
                            <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }} flex={1}>
                                🔁 💰 Bridging asset task
                            </TYPE.desc>
                            <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }} flex={1}>
                                + 5000 Points
                            </TYPE.desc>
                        </AutoColumn>
                    </Row>
                    <Row gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '20px',
                                height: '20px',
                                color: '#F7931A',
                                background: 'rgba(247,147, 26,0.2)',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            2
                        </TYPE.desc>
                        <AutoColumn gap="20px">
                            <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }}>
                                🎯 Satoshi.ai check-in task
                            </TYPE.desc>
                            <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }}>
                                + 1000 Points
                            </TYPE.desc>
                        </AutoColumn>
                    </Row>
                    <Row gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '20px',
                                height: '20px',
                                color: '#F7931A',
                                background: 'rgba(247,147, 26,0.2)',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            3
                        </TYPE.desc>
                        <AutoColumn gap="20px">
                            <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }}>
                                🎯 GOATRocket task
                            </TYPE.desc>
                            <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }}>
                                + 3000 Points
                            </TYPE.desc>
                        </AutoColumn>
                    </Row>
                    <Row gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '20px',
                                height: '20px',
                                color: '#F7931A',
                                background: 'rgba(247,147, 26,0.2)',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            4
                        </TYPE.desc>
                        <AutoColumn gap="20px">
                            <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }}>
                                🔁 Goatswap / Oku task
                            </TYPE.desc>
                            <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }}>
                                + 1500 Points
                            </TYPE.desc>
                        </AutoColumn>
                    </Row>
                </Grid>
            </div>
        ),
    },
    {
        title: 'Step3: Invite your friends',
        desc: 'Gain more points by inviting more users',
        icon: StyledCopySVG,
        buttonText: 'Copy',
        isCopy: true,
        contentRender: () => (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: '#1C1C1C',
                    borderRadius: '16px',
                    padding: '20px',
                    gap: '16px',
                }}
            >
                <TYPE.main>Invite more friends, gain Points</TYPE.main>
                <Grid col={4} gap="10px">
                    <RowBetween gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '20px',
                                height: '20px',
                                color: '#F7931A',
                                background: 'rgba(247,147, 26,0.2)',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            1
                        </TYPE.desc>
                        <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }} flex={1}>
                            Lv1. 1-10 &nbsp;+10% Basic Points
                        </TYPE.desc>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '50px',
                                height: '24px',
                                color: '#5FD15C',
                                background: '#5FD15C33',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            + 10%
                        </TYPE.desc>
                    </RowBetween>
                    <RowBetween gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '20px',
                                height: '20px',
                                color: '#F7931A',
                                background: 'rgba(247,147, 26,0.2)',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            2
                        </TYPE.desc>
                        <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }} flex={1}>
                            Lv2. 11-20 &nbsp;+15% Basic Points
                        </TYPE.desc>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '50px',
                                height: '24px',
                                color: '#5FD15C',
                                background: '#5FD15C33',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            + 15%
                        </TYPE.desc>
                    </RowBetween>
                    <RowBetween gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '20px',
                                height: '20px',
                                color: '#F7931A',
                                background: 'rgba(247,147, 26,0.2)',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            3
                        </TYPE.desc>
                        <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }} flex={1}>
                            Lv3. 21-30 &nbsp;+20% Basic Points
                        </TYPE.desc>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '50px',
                                height: '24px',
                                color: '#5FD15C',
                                background: '#5FD15C33',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            + 20%
                        </TYPE.desc>
                    </RowBetween>

                    <RowBetween gap="10px" style={{ padding: '12px 10px', background: '#121212', borderRadius: '8px' }}>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '20px',
                                height: '20px',
                                color: '#F7931A',
                                background: 'rgba(247,147, 26,0.2)',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            4
                        </TYPE.desc>
                        <TYPE.desc fontSize="12px" style={{ textWrap: 'wrap' }} flex={1}>
                            Lv4. 31+ &nbsp;+25% Basic Points
                        </TYPE.desc>
                        <TYPE.desc
                            fontSize="12px"
                            style={{
                                width: '50px',
                                height: '24px',
                                color: '#5FD15C',
                                background: '#5FD15C33',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            + 25%
                        </TYPE.desc>
                    </RowBetween>
                </Grid>
            </div>
        ),
    },
];

export default function NewRouteline() {
    // const { hasPreMined } = usePreMining();
    // const { isMinted, nextTokenId } = useCapsuleMethods();
    const [activeStep, setActiveStep] = useState(0);
    const history = useHistory();

    const getInviteLink = () => {
        if (!user.opsUser?.inviteCode) return '';
        const origin = typeof window !== 'undefined' ? window.location.origin : '';
        return `${origin}/invite/${user.opsUser.inviteCode}`;
    };

    const TimeLineConfig = [
        {
            content: () => (
                <AutoColumn gap="40px">
                    <Season4Wrapper>
                        <AutoColumn style={{ textAlign: 'center' }} gap={isMobile ? '10px' : '20px'}>
                            <AutoColumn style={{ gap: '6px' }}>
                                <TYPE.desc fontSize="40px" mobileFz={24} fontWeight={500}>
                                    Season 4 Has End
                                </TYPE.desc>
                                <TYPE.desc fontSize="12px" mobileFz={12}>
                                    2025.11.17 2PM (UTC) ~ 2026.4.17 2PM (UTC)
                                </TYPE.desc>
                            </AutoColumn>
                            <TYPE.desc fontSize="32px" mobileFz={24}>
                                Double rewards: BTC + GOATED
                            </TYPE.desc>
                            <TYPE.desc fontSize="16px" mobileFz={12}>
                                Bridge Assets To GOAT Network · Explore New DApps
                            </TYPE.desc>
                        </AutoColumn>
                        {/* <RowBetween gap="10px" style={{ width: '300px' }}> */}
                        <LinkLuckyDrawButton
                            onClick={() => {
                                window.open('https://bridge.goat.network', '_blank');
                            }}
                        >
                            <TYPE.desc fontSize="16px" mobileFz={10}>
                                Start Bridging
                            </TYPE.desc>
                            <MuiButton style={{ background: '#f7931a', cursor: 'pointer' }}>
                                <ArrowIcon color="#000" width={8} height={8} />
                            </MuiButton>
                        </LinkLuckyDrawButton>
                        {/* <LinkLuckyDrawButton
                                onClick={() => {
                                    history.push({
                                        pathname: luckyDrawPath,
                                        search: location.search,
                                        state: { scrollTo: 'lucky-draw-pool' },
                                    });
                                }}
                            >
                                <TYPE.desc fontSize="16px" mobileFz={10}>
                                    Lucky Draw
                                </TYPE.desc>
                                <MuiButton style={{ background: '#f7931a', cursor: 'pointer' }}>
                                    <ArrowIcon color="#000" width={8} height={8} />
                                </MuiButton>
                            </LinkLuckyDrawButton> */}
                        {/* </RowBetween> */}
                    </Season4Wrapper>
                </AutoColumn>
            ),
        },
        {
            title: 'Mission Center Quick Start',
            desc: 'Complete social and on-chain tasks to earn points. Join Discord to join the raffle!',
            started: true,
            rowDirection: 'row-start',
            canMint: missionStore.canMint,
            content: () => <MissionCenter />,
        },
        {
            title: 'Galactic Exploration Begins',
            desc: 'Collaborate with fellow explorers to establish a vital Earth-Moon Transit Base.',
            tag: 'Season 3',
            img: Season4Img,
            imgWidth: isMobile ? 120 : 355,
            started: true,
            rowDirection: 'row-end',
            content: () => (
                <ExpandableSection defaultExpanded={false}>
                    <AutoColumn gap="40px" style={{ marginTop: '40px' }}>
                        <ShareContentWrapper>
                            <AutoColumn>
                                <TYPE.desc fontSize="40px" mobileFz={24} fontWeight={500}>
                                    Season 3 Has Ended
                                </TYPE.desc>
                                <TYPE.desc fontSize="16px" mobileFz={12} textAlign="center">
                                    Start Date: 7.18 0AM (UTC) ～ 11.17 12PM (UTC)
                                </TYPE.desc>
                            </AutoColumn>
                            <Copy
                                text={getInviteLink()}
                                render={(onCopy) => (
                                    <div
                                        onClick={onCopy}
                                        style={{
                                            border: '1px solid #F7931A',
                                            padding: '12px 20px',
                                            borderRadius: '40px',
                                            height: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '10px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <TYPE.desc fontSize="16px" mobileFz={12}>
                                            Invite your friends to join Season 3 campaign
                                        </TYPE.desc>
                                        <MuiButton
                                            style={{ background: '#F7931A4D', cursor: 'pointer' }}
                                            onClick={() => {}}
                                        >
                                            <img src={LinkSvg} alt="link" />
                                        </MuiButton>
                                    </div>
                                )}
                            />
                            <AutoRow justifyContent="center" gap="5px" textAlign="center" width="auto">
                                <DiscordIcon />
                                <TYPE.desc fontSize="16px" mobileFz={10}>
                                    Join Discord to win airdrop
                                </TYPE.desc>
                                <MuiButton
                                    style={{ background: '#f7931a', cursor: 'pointer' }}
                                    onClick={() => {
                                        window.open('https://discord.com/invite/goatnetworkofficial', '_blank');
                                    }}
                                >
                                    <ArrowIcon color="#000" width={8} height={8} />
                                </MuiButton>
                            </AutoRow>
                        </ShareContentWrapper>
                    </AutoColumn>
                </ExpandableSection>
            ),
        },
        {
            title: 'Build the Mars Guardian Outpost',
            desc: 'Embark on an ambitious mission to construct the Mars Guardian Outpost.',
            tag: 'Season 2',
            img: Season3Img,
            imgWidth: isMobile ? 120 : 220,
            started: true,
            style: {
                marginBottom: isMobile ? '115px' : '40px',
                marginTop: isMobile ? '20px' : '0px',
            },
            rowDirection: 'row-start',
            easterEgg: () => (
                <EasterEggWrapper
                    right={isMobile ? 'unset' : '0px'}
                    left={isMobile ? '140px' : 'unset'}
                    top={isMobile ? '-10px' : '20px'}
                >
                    <EasterEgg modalTitle="Lucky Draw #2" title="Lucky Draw" mask={true} />
                </EasterEggWrapper>
            ),
            content: () => (
                <ExpandableSection defaultExpanded={false}>
                    <AutoColumn gap="40px" style={{ marginTop: '40px' }}>
                        <ShareContentSeason2Wrapper>
                            <AutoColumn>
                                <TYPE.desc fontSize="40px" mobileFz={24} fontWeight={500}>
                                    Season 2 Has Ended
                                </TYPE.desc>
                                <TYPE.desc fontSize="16px" mobileFz={12} textAlign="center">
                                    6.17 2PM (UTC) ～ 7.7 2PM (UTC)
                                </TYPE.desc>
                            </AutoColumn>
                            <Copy
                                text={getInviteLink()}
                                render={(onCopy) => (
                                    <div
                                        onClick={onCopy}
                                        style={{
                                            border: '1px solid #F7931A',
                                            padding: '12px 20px',
                                            borderRadius: '40px',
                                            height: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '10px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <TYPE.desc fontSize="16px" mobileFz={12}>
                                            Invite your friends to join Season2 campaign
                                        </TYPE.desc>
                                        <MuiButton
                                            style={{ background: '#F7931A4D', cursor: 'pointer' }}
                                            onClick={() => {}}
                                        >
                                            <img src={LinkSvg} alt="link" />
                                        </MuiButton>
                                    </div>
                                )}
                            />
                            <AutoRow justifyContent="center" gap="5px" textAlign="center" width="auto">
                                <MuiButton
                                    style={{
                                        border: '2px solid #fff',
                                        borderRadius: 10,
                                        background: 'transparent',
                                        width: 32,
                                        height: 32,
                                    }}
                                    onClick={() => {}}
                                >
                                    <img src={Xsvg} alt="x" />
                                </MuiButton>
                                <TYPE.desc fontSize="16px" mobileFz={10}>
                                    Share on Twitter
                                </TYPE.desc>
                                <MuiButton
                                    style={{ background: '#f7931a', cursor: 'pointer' }}
                                    onClick={() => {
                                        SocialMediaShare(
                                            'twitter',
                                            `One Piece Season 2 is live! 🚀\nJoin the community, complete on-chain quests, and earn rewards.\nInvite your friends and let's explore together! #OnePiece #GOATNetwork\n${getInviteLink()}`,
                                        );
                                    }}
                                >
                                    <ArrowIcon color="#000" width={8} height={8} />
                                </MuiButton>
                            </AutoRow>
                        </ShareContentSeason2Wrapper>
                        <div>
                            <div>
                                <TYPE.title fontSize="40px" mobileFz={24} fontWeight={500}>
                                    User Journey
                                </TYPE.title>
                                <TYPE.desc>
                                    Complete on-chain tasks, verify your interactions, and invite friends to join the
                                    One Piece.
                                </TYPE.desc>
                            </div>
                            <Grid col={3} style={{ margin: '40px 0 20px 0' }}>
                                {stepsConfig.map((step, index) => (
                                    <>
                                        <StepCard
                                            onClick={() => setActiveStep(index)}
                                            key={index}
                                            isActive={activeStep === index}
                                        >
                                            <AutoColumn gap="10px">
                                                <TYPE.main fontWeight={700} fontSize="14px">
                                                    {step.title}
                                                </TYPE.main>
                                                {step.desc && <TYPE.desc fontSize="12px">{step.desc}</TYPE.desc>}
                                            </AutoColumn>
                                            {step.isCopy ? (
                                                <StepButton
                                                    icon={step.icon}
                                                    buttonText={step.buttonText}
                                                    isCopy={step.isCopy}
                                                    text={step.isCopy ? getInviteLink() : undefined}
                                                />
                                            ) : step.title === STEP_2_TITLE ? (
                                                <StepButtonWithNavigation
                                                    icon={step.icon}
                                                    buttonText={step.buttonText}
                                                />
                                            ) : (
                                                <StepButton icon={step.icon} buttonText={step.buttonText} />
                                            )}
                                        </StepCard>
                                        {isMobile && activeStep === index && step.contentRender()}
                                    </>
                                ))}
                            </Grid>
                            {!isMobile && stepsConfig[activeStep].contentRender()}
                        </div>
                    </AutoColumn>
                </ExpandableSection>
            ),
        },
        {
            title: 'Build Earth-Moon Transit Base',
            desc: 'Bridge assets, lock BTC, complete transactions, and engage with dApps to enhance your capsule, transforming it into a hub for strategic missions, and preparation for greater interstellar challenges.',
            tag: 'Season 1',
            img: Season2Img,
            imgWidth: isMobile ? 120 : 256,
            started: true,
            style: {
                marginBottom: isMobile ? '40px' : '100px',
            },
            rowDirection: 'row-end',
            content: () => <AssetsList />,
        },
    ];

    return (
        <Wrapper>
            <OverviewBox />
            {TimeLineConfig.map((item, index) => {
                if (!item) return null;
                return (
                    <Step key={index} className={classNames('step', item.rowDirection)}>
                        <Flex
                            style={{
                                flexDirection: item.rowDirection === 'row-start' ? 'row' : 'row-reverse',
                                gap: isMobile ? '20px' : '60px',
                                alignItems: isMobile ? 'flex-start' : 'flex-start',
                                ...item.style,
                            }}
                        >
                            {item.img ? (
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    style={{
                                        width: item.imgWidth,
                                        height: 'auto',
                                        maxWidth: '100%',
                                        objectFit: 'contain',
                                        animation: 'move 5s infinite alternate',
                                        animationDelay: `${index * 1.5}s`,
                                    }}
                                />
                            ) : null}
                            {item.title === 'Mission Center Quick Start' ? null : (
                                <div className="row" style={{ paddingTop: '24px' }}>
                                    <RelativeWrapper>
                                        {item.tag ? (
                                            <div className="season" style={{ opacity: item.started ? 1 : 0.5 }}>
                                                {item.tag}
                                            </div>
                                        ) : null}
                                        {/* {!item.started ? <ComingSoon top="-16px" right="-40%" /> : null} */}
                                    </RelativeWrapper>
                                    <div className="cardTitle">
                                        <TYPE.title fontSize={38} mobileFz={24}>
                                            {item.title}
                                        </TYPE.title>
                                    </div>
                                    {!!item.desc && (
                                        <div
                                            className="cardDesc"
                                            style={{ textAlign: item.rowDirection === 'row-start' ? 'left' : 'right' }}
                                        >
                                            {item.desc}
                                            {!item.started && (
                                                <div style={{ marginTop: isMobile ? '10px' : '16px' }}>
                                                    Coming Soon ...
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </Flex>
                        {item.content ? item.content() : null}
                        {item.easterEgg ? item.easterEgg() : null}
                    </Step>
                );
            })}
        </Wrapper>
    );
}
